<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field
          :value="value.name"
          label="名前*"
          type="text"
          outlined
          hide-details
          single-line
          @input="update('name', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          :value="value.phoneNumber"
          label="電話番号*"
          type="phone"
          outlined
          hide-details
          single-line
          @input="update('phoneNumber', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          :value="value.email"
          label="メール*"
          type="email"
          outlined
          hide-details
          single-line
          :disabled="user && !!user.email"
          @input="update('email', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          :value="value.postalCode"
          label="郵便番号*"
          type="number"
          outlined
          hide-details
          single-line
          @input="update('postalCode', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          :items="prefectures"
          label="都道府県*"
          :value="value.prefecture"
          outlined
          hide-details
          single-line
          @input="update('prefecture', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          :value="value.address"
          label="住所*"
          type="text"
          outlined
          hide-details
          single-line
          @input="update('address', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          :value="value.address2"
          label="以降の住所"
          type="text"
          outlined
          hide-details
          single-line
          @input="update('address2', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col> * are required </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PREFECTURES } from '@/helpers/prefectures'
import { createNamespacedHelpers } from 'vuex'

const userStore = createNamespacedHelpers('user')

export default {
  props: {
    value: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    prefectures: PREFECTURES.map((v) => v.prefecture_kanji)
  }),
  computed: {
    ...userStore.mapState(['userId', 'user'])
  },
  methods: {
    update(field, value) {
      this.$emit('input', {
        ...this.value,
        [field]: value
      })
    }
  }
}
</script>
